import isNode from '../../modules/ajio-util/isNode';

export const setProductStoreMappingData = (userId, itemCode, sourseStoreId) => {
  if (isNode()) {
    return;
  }
  const isLocal = localStorage.getItem('productStoreMapping');
  if (isLocal === null) {
    const data = JSON.stringify({ [userId]: { [itemCode]: sourseStoreId } });
    localStorage.setItem('productStoreMapping', data);
  } else {
    const prevData = JSON.parse(localStorage.getItem('productStoreMapping'));
    const filteredData = Object.keys(prevData)
      .filter(key => key === userId)
      .reduce((obj, key) => {
        obj[key] = prevData[key];
        return obj;
      }, {});
    if (Object.keys(filteredData).length > 0) {
      delete prevData[userId];
      const products = filteredData[userId];
      const filterdProducts = Object.keys(products)
        .filter(key => key === itemCode)
        .reduce((obj, key) => {
          obj[key] = filteredData[key];
          return obj;
        }, {});
      if (Object.keys(filterdProducts).length > 0) {
        delete products[userId];
      }
      const newProduct = { ...products, [itemCode]: sourseStoreId };
      const newData = JSON.stringify({ ...prevData, [userId]: newProduct });
      localStorage.setItem('productStoreMapping', newData);
    } else {
      const newData = JSON.stringify({ ...prevData, [userId]: { [itemCode]: sourseStoreId } });
      localStorage.setItem('productStoreMapping', newData);
    }
  }
};

export const getProductStoreMappingData = (userId, itemCode) => {
  if (isNode()) {
    return;
  }
  const isLocal = localStorage.getItem('productStoreMapping');
  if (isLocal) {
    const prevData = JSON.parse(localStorage.getItem('productStoreMapping'));
    const filteredData = Object.keys(prevData)
      .filter(key => key === userId)
      .reduce((obj, key) => {
        obj[key] = prevData[key];
        return obj;
      }, {});
    if (Object.keys(filteredData).length > 0) {
      const products = filteredData[userId];
      let isLuxe;
      Object.keys(products).forEach(key => {
        if (key === itemCode) return (isLuxe = products[key]);
      });
      if (isLuxe) return isLuxe;
      return '';
    }
    return '';
  }
};
